export default "__VITE_ASSET__2fc84773__"